import { createRef, useEffect, useState } from "react";
import { SnackbarProvider } from "notistack";
import { Button, IconButton, Slide } from "@mui/material";
import { Helmet } from "react-helmet-async";

// routes
import Routers from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
// components
import ScrollToTop from "./components/ScrollToTop";
import { ContextPGIMode } from "./Hooks/PGIModeContext";
import { project_name } from "./config/config";
import { Icon } from "@iconify/react";

// ----------------------------------------------------------------------

export default function App() {
  const [metaTitle, setMetaTitle] = useState(project_name);
  const notistackRef = createRef();

  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  useEffect(() => {
    setMetaTitle(localStorage.getItem("metaTitle") || project_name);
  }, []);

  return (
    <ContextPGIMode>
      <ThemeConfig>
        <ScrollToTop />
        <GlobalStyles />

        <SnackbarProvider
          ref={notistackRef}
          maxSnack={3}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          TransitionComponent={Slide}
          action={(key) => (
            <IconButton
              onClick={onClickDismiss(key)}
              size="small"
              sx={{
                minWidth: "auto",
                color: "#fff",
                marginRight: 1,
                borderRadius: "50%",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.15)", 
                },
              }}
            >
              <Icon icon="mdi:close" width={16} height={16} />
            </IconButton>

          )}
        >
          <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content="Admin Panel" />
          </Helmet>
          <Routers />
        </SnackbarProvider>
      </ThemeConfig>
    </ContextPGIMode>
  );
}